import React from 'react';
import PopupInjector from '@src/components/Popup/PopupInjector';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import FormField, {Props} from '@src/components/Form/FormField';
import FormFieldLabel from '@src/components/Form/FormFieldLabel';
import {uniqueId} from '@src/helpers/uniqueId';
import Popup from '@client/src/components/Popup/Popup';
import {ReplaceWithComponents} from '@src/components/Translate/Translate';
import useFormValue from '@src/hooks/useFormValue';

function RichDescriptionPopup(props: {
    closePopup: () => void,
    description: string,
}) {
    return <Popup closePopup={props.closePopup} width={700}>
        <ReplaceWithComponents
                message={props.description.replace(/\r\n|\r|\n/guim, ':br ')}
                replace={{
                    'br': <br/>,
                }}
        />
    </Popup>;
}

const OpenDescriptionInPopupButtonMemoized = React.memo(function OpenDescriptionInPopupButton(props: {
    orderId?: string | number | null,
    description?: string | null
}) {
    const orderId = props.orderId ?? uniqueId();
    const description = props.description;
    if (!description) {
        return null;
    }

    return <PopupInjector
            popupName={`order-${orderId}-rich-description-popup`}
            renderPopup={props => <RichDescriptionPopup {...props} description={description}/>}
            renderButton={props => {
                return <button
                        type="button"
                        className="btn btn-sm btn-link ms-2"
                        onClick={props.openPopup}
                >
                    <i className="fa fa-eye"/>
                </button>;
            }}
    />;
});

function Label<Model extends IOrderModel = IOrderModel>(props: Props<Model> & {
    labelId: string,
    labelText: string,
}) {
    const {currentValue} = useFormValue('description');

    return <FormFieldLabel {...props} labelElement={undefined}>
        <OpenDescriptionInPopupButtonMemoized
                orderId={props.model?.id}
                description={currentValue ?? props.model?.description}
        />
    </FormFieldLabel>;
}

export default function OrderDescriptionField<
        Model extends IOrderModel = IOrderModel
>(props: Props<Model>) {
    return <FormField {...props} labelElement={Label<Model>}/>;
}
